class AbProductModal extends HTMLElement {
    constructor(){
        super();
        
       this.buttons = document.querySelectorAll("[data-popup-button]");
       this.overlay = this.querySelector(".ab-modal-overlay");
       this.closeButton = this.querySelector(".ab-modal-close");
       this.modalContent = this.querySelector(".ab-modal-content");
       this.sectionId = document.querySelector(".ab-product-main")?.dataset.personalisedId;
    }
    connectedCallback(){
       this.buttons.forEach(button => {
            button.addEventListener("click", this.handleClick.bind(this));
        });
        this.closeButton.addEventListener("click", () => {
            this.close();
        });
        this.overlay.addEventListener("click", () => {
            this.close();
        });  
    }
    handleClick(e){
        e.stopPropagation();
        const button = e.currentTarget;
        const productHandle = button.dataset.productHandle;

        button.classList.add('ab-loading');
        button.disabled = true;


        fetch(`${productHandle}?section_id=${this.sectionId}`)
            .then(response => response.text())
            .then(data => {
                const tempDiv = document.createElement("div");
                tempDiv.innerHTML = data;
    
             const productHtml = tempDiv.querySelector(".ab-product-modal-content").innerHTML;
             
            if (productHtml) {
                this.modalContent.innerHTML = productHtml;
                this.open();
            }
        })
        .catch(error => {
            console.error('Error loading product:', error);
        })
        .finally(() => {
            button.classList.remove('ab-loading');
            button.disabled = false;
        });
        
    }
    open(){
        this.setAttribute("open", "");
    }
    close() {
         this.removeAttribute("open");
    }
} 

customElements.define('ab-product-modal', AbProductModal);